import React, { useState, useEffect, useRef, divRef } from "react";
import { alert_error, alert_success } from "../../../../AppContext";
import { Cookies } from "../../../../index.js";
import Iframe from 'react-iframe';
import { useLocation } from 'react-router-dom';
import axios from "axios";
import AdSense from 'react-adsense';
import { ClipLoader, PulseLoader } from 'react-spinners';
const Jopsearch = () => {
  const iframeId = 'iframeContainer'; // Đặt id cho phần tử div
  const [iframeHeight, setIframeHeight] = useState(null); //None Kích thước mặc định
  const location = useLocation();
  const recaptchaRef = React.createRef();
  const [currentStep, setCurrentStep] = useState(1);
  const [nutorder, setnutorder] = useState("Xác nhận");
  const [nutxuly, setnutxuly] = useState(0);
  const [isDisabled, setIsDisabled] = useState(false);
  const [iframeKey, setIframeKey] = useState(0);
  const [chuadangnhap, setchuadangnhap] = useState(true);
  const [gtoken, setgtoken] = useState('');
  const [chedo, setchedo] = useState(false);
  const [loadcheoweb, setloadcheoweb] = useState(false);
  const [data_ok, setdata_ok] = useState(null);
  const [datajoptiktok, setDatajoptiktok] = useState('');
  const [linkweb, setLinkweb] = useState(""); // Khai báo biến linkweb ở đây và khởi tạo giá trị ban đầu là chuỗi rỗng
  const [code_input, setCode] = useState(""); // Khai báo biến code_input để lưu trữ mã
  const [api_key, setapi_key] = useState('');
  const [buttonTextjop, setbuttonTextjop] = useState("Xác Thực Captcha để nhận Coins nhé");
  const [count, setCount] = useState(10);

  useEffect(() => {
    // Tìm phần tử div với id
    const divElement = document.getElementById(iframeId);

    // Nếu phần tử không tồn tại, hãy tạo nó
    if (!divElement) {
      const newDiv = document.createElement('div');
      newDiv.id = iframeId;
      document.body.appendChild(newDiv);
    }

    // Cập nhật kích thước iframe
    const divTop = document.getElementById(iframeId).getBoundingClientRect().top;
    const windowHeight = window.innerHeight * 0.83;
    const newHeight = `${windowHeight - divTop}px`;
    setIframeHeight(newHeight);
  }, []);
  useEffect(() => {
    setTimeout(() => {
      const myCookieValue = Cookies.get('apikey');
      console.log(myCookieValue);
      setapi_key(myCookieValue);
    }, 100);
  }, []);
  useEffect(() => {
    const myCookieValue = Cookies.get('apikey');
    if (myCookieValue) {
      if (api_key != '') {
        setchuadangnhap(false);
      }
    }
    setTimeout(() => {
      if (myCookieValue) {
        if (api_key != '') {
          setchuadangnhap(false);
          laydulieujop();
        }
      }
      else {
        setIsDisabled(true);
        setchuadangnhap(true);
      }
    }, 400);

  }, [api_key]);
  const handleContinue = () => {
    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    } else {
      // Nếu ở bước cuối, quay lại bước đầu
      setCurrentStep(1);
    }
  };
  const laydulieujop = async () => {
    setIsDisabled(false);
    setDatajoptiktok('');
    setdata_ok(null);
    if (location.pathname.includes('/testmaps')) {
      const jasdjnlaksdl = 'search';
      sadasdasdasdasd(jasdjnlaksdl);
      setchedo(jasdjnlaksdl);
    }
    else {
      const jasdjnlaksdl = 'search';
      sadasdasdasdasd(jasdjnlaksdl);
      setchedo(jasdjnlaksdl);
    }
  };
  function sadasdasdasdasd(jasdjnlaksdl) {
    const myCookieValue = Cookies.get("apikey");
    const code_item = Cookies.get("code_item");
    const hustmediavipro = Cookies.get("hustmediavipro");
    axios.get('https://hust.media/link/load_mode/mode_maps_start.php', {
      params: {
        lienket: hustmediavipro,
        apikey: myCookieValue,
        code_item: code_item
      },
    })
      .then(response => {
        console.log(response.data);
        if (response.data.status != 1 && response.data.message != '') {
          alert_error(response.data.message);
          //   chuyenhuong(response.data);
        }
        else if (response.data.status == 1) {
          setDatajoptiktok(response.data.datajop[0]);
          setdata_ok(response.data.datajop);
          console.log(response.data.datajop[0]);
          if (response.data.datajop[0].name_place) {
            // setLinkweb(response.data.datajop[0].lienketjop);
            alert_success('Lấy dữ liệu jop thành công');
            console.log(response.data.datajop);
          }
        }
        else {
          alert_error('Đã xảy ra lỗi máy chủ vui lòng liên hệ admin');
        }
        // testFunction(response);
      })
      .catch(error => {
        console.error(error);
      });
  };
  function chuyenhuong(data) {
    // Xử lý dữ liệu ở đây
    console.log(data);
    if (data.status == 0 || data.status == "0") {

    }
    else if (data.router == false) {
      setTimeout(function () {
        window.location.href = data.redirects;
      }, 1500);
    }
    else {

    }
  };
  const resetRecaptcha = () => {
    window.grecaptcha.reset();
    setgtoken(null);
  };
  function testFunction(response) {
    if (chedo == 'cheoweb') {
      setloadcheoweb(false);
      reloadIframe();
      resetRecaptcha();
      setbuttonTextjop('Xác Thực Captcha');
      setCount(15);
    }

    // const orderok = info.order;
    // const error = info.error;
    setnutorder("đặt tiếp luôn nào");
    setnutxuly(0);
    if (response.data.status == 0) {
      alert_error(response.data.message);
      // chuyenhuong(response.data);
      // laydulieujop();
    }
    else if (response.data.status == 1) {
      alert_success(response.data.message);
    }
    else {
      alert_error('Đã xảy ra lỗi máy chủ vui lòng liên hệ admin');
    }
    if (response.data.redirect != null && response.data.redirect != '') {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = response.data.redirect;
      }, 1700);
    }
  };
  function saochep(value) {
    alert_success('Đã sao chép');
    window.saochepnative(value);

  };
  function handleSubmit(event) {
    if (!code_input) {
      alert_error("Please điền đầy đủ thông tin");
      setnutxuly(0);
      return;
    }
    const apikey = Cookies.get("apikey");
    const code_item = Cookies.get("code_item");
    const hustmediavipro = Cookies.get("hustmediavipro");
    event.preventDefault();

    setnutxuly(1);
    setnutorder("Please wait a moment 😊");
    axios
      .get("https://hust.media/link/load_mode/mode_maps_end.php", {
        params: {
          apikey: apikey,
          lienket: hustmediavipro,
          link_reviews: code_input,
          code_item: code_item
        },
      })
      .then((response) => testFunction(response))
      .catch((error) => alert_error(error));
  };
  function handleSubmitcheoweb(value) {
    const apikey = Cookies.get("apikey");
    setloadcheoweb(true);
    setnutxuly(1);
    setnutorder("Please wait a moment 😊");
    axios
      .post("https://hust.media/jop/google/checkjop.php", {
        apikey: apikey,
        chedo: chedo,
        code_input: linkweb,
        gtoken: value,

      })
      .then((response) => testFunction(response))
      .catch((error) => alert_error(error));
  };
  const reloadIframe = () => {
    setIframeKey(prevKey => prevKey + 1);
  };

  const stepDescription = {
    1: (
      <div className=" bg-gray-100">
        {datajoptiktok && datajoptiktok.length != 0 && <>
          <div className="p-3 border rounded-lg shadow-lg max-w-lg">
            <div className="flex items-center">
              <span className="mr-2">🔗</span>
              <span className="text-gray-800 text-sm font-medium">Tìm địa điểm ở: </span>{' '}
              <a
                href="https://google.com/maps"
                className="text-blue-600 text-sm"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Maps
              </a>
            </div>
            <div className=" flex items-center">
              <span className="mr-1">🏪</span>
              <span className="text-gray-800 text-sm font-medium">Tên cửa hàng:</span>{' '}
              <span className="text-orange-600 text-sm font-bold">{datajoptiktok.name_place}</span>
            </div>
            <div className=" flex items-center">
              <span className="mr-1">🏪</span>
              <span className="text-gray-800 text-sm font-medium">Mô tả cửa hàng:</span>{' '}
              <span className="text-orange-600 text-sm font-bold"> {datajoptiktok.description}</span>
            </div>
            <div className="border px-1 py-2 flex items-center rounded bg-gray-100">
              <button
                className="mr-2 px-2 text-sm text-white bg-blue-500 rounded"
              // onClick={handleCopy}
              >
                📍Địa chỉ:
              </button>
              <div className="flex-grow text-sm text-gray-900">
                {datajoptiktok.full_address}
              </div>
            </div>
          </div>
        </>}
      </div>
    ),
    2: (
      <div>
        {datajoptiktok && datajoptiktok.length != 0 && <>
          Đánh giá 5 sao
          <div className="p-4 border rounded-lg shadow-lg max-w-lg">
            <div className="text-gray-900">
              {datajoptiktok.name_place}
            </div>
            <div className="flex items-center ">
              <div className="flex text-yellow-500 text-xl">
                {'★'.repeat(5)}
              </div>
              <span className="ml-2 text-sm text-gray-600">8 phút trước</span>
            </div>
            <div className="text-gray-900">
              Tự viết 1 đoạn bình luận (dài hơn 20 ký tự) về trải nghiệm gần đây của bạn về dịch vụ {datajoptiktok.description} .
            </div>
          </div>
        </>}
        <div className="text-sm ">
          LƯU Ý: Review được google hiển thị mới được thưởng,
          có thể dùng nhiều Gmail, thiết bị review nhiều nội dung tự nghĩ khác nhau.
          Review xong check luôn, review nào hiển thị thì nộp báo cáo.
        </div> </div>
    ),
    // 2: "Khi trang tải xong kéo xuống cuối trang click vào nút 'Bấm đây để lấy mã' để tiếp tục.",
    3: (<div className=" bg-gray-100">
      {datajoptiktok && datajoptiktok.length != 0 && <>
        <div className="max-w-xl w-full p-2 space-y-2 bg-white rounded-md shadow-md text-center">
          {/* Các nút và văn bản đẹp */}
          <div className="text-black text-lg">
            Tìm đến nút <strong className="text-blue-500">"Chia sẻ reviews của bạn"</strong> để tiếp tục.
          </div>
          <div className="text-black text-sm">
            Sao chép link reviews và điền ở ô phía dưới.
          </div>
        </div>       </>}</div>),
  };

  const stepColors = {
    1: "bg-red-400",
    2: "bg-purple-400",
    3: "bg-blue-400",
  };
  const handleRecaptchaChange = (value) => {
    console.log(value);
    const maxLength = 200;

    if (value.length > maxLength) {

      // setnutxuly(1);
      setbuttonTextjop('Bạn hãy đợi vài giây để app xử lý nhé');
      setgtoken(value);
      handleSubmitcheoweb(value);
    }
    else {
      setbuttonTextjop('Đã xảy ra lỗi tải lại trang nhé');
    }
  }
  return (
    <div>
      <div className="w-full h-full flex flex-col  justify-center items-center">
        <div className="mt-1 p-2  max-w-[500px] rounded-lg shadow-xl bg-gradient-to-r from-pink-400 to-purple-400">
          <div className="px-1" >
            {!chuadangnhap &&
              (<>
                <h1 className="text-xl font-bold text-white mb-1">HƯỚNG DẪN xem LINK</h1>
                <p className="text-base text-white mb-2">
                  Lưu ý: Vui lòng không sử dụng (VPN), 1.1.1.1 khi vượt link.
                </p></>)
            }
            <div id={iframeId} >    </div>
            {!chuadangnhap && (<>     {

              !data_ok && !chuadangnhap ? (
                <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                  <ClipLoader color="#fff" size={150} />
                </div>
              ) :

                data_ok.length === 0 && (location.pathname.includes('/testmaps') || location.pathname.includes('/cheoweb')) && (
                  <>
                    <h2>Hết nhiệm vụ, vui lòng xem xét làm jop khác hoặc mua sắm để hỗ trợ cộng đồng. 🛍️</h2>
                  </>
                )}
            </>)}
            {chuadangnhap ? (<>
              <div className="z-index-1 position-relative">
                <a className="link-light mb-4 font-sans-serif fs-4 d-inline-block fw-bolder" href="/">hust.media</a>
                <p className="opacity-75 text-black">Là một hệ thống trao đổi tương tác một cách tự nhiên và an toàn. Hệ thống hoạt động theo nguyên tắc tự nguyện trao đổi giữa các thành viên, cùng giúp nhau tăng tương tác, tăng hiệu quả bán hàng, truyền thông.<br />#traodoisub , #tangsub, #tuongtaccheo, #tuongtacfb, #tangtheodoimienphi, #tanglikemienphi, #tanglike, #tangtheodoi, #tangcmt, #tangcamxuc, #tangshare, #cayxu, #toolcayxu, #tangview, #tangtiktok, #traodoitiktok, #tiktok </p>
              </div>
            </>) : (
              <>{data_ok && data_ok.length != 0
                ? (
                  <>
                    {datajoptiktok.name_place && (<>    <div className="flex text-base flex-col gap-4">
                      {Object.keys(stepDescription).map((step) => (
                        <div
                          key={step}
                          className={`rounded-lg p-3 ${stepColors[step]} ${currentStep === parseInt(step) ? "block" : "hidden"
                            }`}
                        >
                          <div className="mx-auto flex justify-between items-center w-full max-w-lg">
                            <h2 className="text-xl font-bold text-white">Bước {step}</h2>
                            <button
                              type="button"
                              className="bg-white text-purple-400 font-bold py-2 px-4 mb-1 rounded"
                              onClick={handleContinue}
                            >
                              {currentStep < 3 ? "Tiếp tục" : "Quay lại Bước 1"}
                            </button>
                          </div>

                          <p className="text-lg text-white mb-2">{stepDescription[step]}</p>
                          {currentStep === parseInt(step) ? (
                            <div className="flex gap-2">
                              {currentStep === 1 && (
                                <button
                                  onClick={() => saochep(datajoptiktok.full_address)}
                                  type="button"
                                  className="bg-blue-500 text-white font-bold py-2 px-4 rounded"
                                >
                                  Sao chép
                                </button>
                              )}

                              {/* <button
                                type="button"
                                className="bg-white text-purple-400 font-bold py-2 px-4 rounded"
                                onClick={handleContinue}
                              >
                                {currentStep < 3 ? "Tiếp tục" : "Quay lại Bước 1"}
                              </button> */}
                            </div>
                          ) : null}
                        </div>
                      ))}
                    </div>

                      {/* Ô nhập mã */}
                      {currentStep > 2 && (<div className="mt-3 p-4 bg-gradient-to-r from-pink-200 to-purple-200 rounded-md shadow-md">
                        <div >
                          <h2 className="text-xl font-bold text-white mb-2">Nhập link reviews ở đây:</h2>
                          <div className="relative flex">
                            <input
                              type="text"
                              className="border-2 border-pink-400 rounded-md p-3 pl-10 w-full focus:outline-none focus:border-pink-500"
                              placeholder="Nhập link reviews ở đây"
                              value={code_input}
                              onChange={(e) => setCode(e.target.value)}
                            />
                            <div className="absolute left-3 top-3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                className="h-6 w-6 text-pink-400"
                              >
                                {/* Icon sao chép */}
                              </svg>
                            </div>
                            <button
                              disabled={nutxuly}
                              type="button"
                              className="bg-pink-400 text-white font-bold py-2 px-3 rounded-md ml-2"
                              onClick={handleSubmit}
                            >
                              {nutxuly == 1 && (
                                <div className="spinner-border" role="status"></div>
                              )}

                              <span className="text-lg font-medium text-white">
                                {nutorder}{" "}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>)} </>)}


                  </>
                ) :
                data_ok && data_ok.length != 0 && location.pathname.includes('/cheoweb') && (
                  <>
                  </>
                )
              }</>)}
          </div>
          <div className="max-h-16">
            <div className="cards">
              <AdSense.Google
                client="ca-pub-4574266110812955"
                slot="1627514116"
                format="horizontal"
              />   </div>
          </div>
        </div>

      </div>

    </div>
  );
};

export default Jopsearch;
